<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 18 18"
		fill="currentColor"
		xmlns="http://www.w3.org/2000/svg"
	>
		<mask
			id="mask0_422_2345"
			style="mask-type: alpha"
			maskUnits="userSpaceOnUse"
			x="0"
			y="3"
			width="18"
			height="12"
		>
			<path
				d="M18 4.5V9C18 9.45 17.7 9.75 17.25 9.75C16.8 9.75 16.5 9.45 16.5 9V6.3L10.65 12.15C10.35 12.45 9.9 12.45 9.6 12.15L6.375 8.925L1.275 14.025C1.125 14.175 0.975 14.25 0.75 14.25C0.525 14.25 0.375 14.175 0.225 14.025C-0.075 13.725 -0.075 13.275 0.225 12.975L5.85 7.35C6.15 7.05 6.6 7.05 6.9 7.35L10.125 10.575L15.45 5.25H12.75C12.3 5.25 12 4.95 12 4.5C12 4.05 12.3 3.75 12.75 3.75H17.25C17.325 3.75 17.475 3.75 17.55 3.825C17.7 3.9 17.85 4.05 17.925 4.2C18 4.275 18 4.425 18 4.5Z"
				fill="currentColor"
			/>
		</mask>
		<g mask="url(#mask0_422_2345)">
			<rect width="18" height="18" fill="currentColor" />
		</g>
	</svg>
</template>

<script>
export default {
	props: {
		size: {
			type: [String, Number],
			default: 18,
		},
	},
};
</script>

<style></style>
